export const LEMA_SUPPORT_EMAIL = 'support@lema.ai'
export const LEMA_USER_ID = 'Lema'
